import {
    initialVenueAnalysisDataState,
    initialVenueAnalysisStreamState,
    VenueAnalysisDataState,
    VenueAnalysisStreamState,
} from './VenueAnalysisStreamDataState';
import {
    VenueAnalysisDataElement,
    VenueAnalysisTimeSeriesElement,
} from '../../api/VenueAnalysisElement';
import {
    mapFullInfoFromStream,
    mapOrderInfoFromStream,
    mapQtyInfoFromStream,
    mapToVenueAnalysisDataTimeSeriesItemFromElement,
} from 'widgets/venueAnalysis/store/stream/mapping';
import timeSeriesReducer from 'utils/timeseries/timeSeriesUtils';
import { StreamElementType } from 'communication/types/StreamElementType';
import streamMessagesReducer from 'utils/messages/StreamMessage';
import { StreamMessageElement } from 'communication/types/StreamElement';
import { VenueAnalysisStreamElementType } from 'widgets/venueAnalysis/api/VenueAnalysisStreamElementType';
import { buildStreamedDataStreamSlice } from 'streamsState/store/streamedData/streamSlice';
import State from 'store/State';
import { selectStreamedDataState } from 'streamsState/store/streamedData/selectors';
import {
    createWidgetRequestUid,
    toRequestUidForConfigOrSymbol,
} from 'widgets/venueAnalysis/store/stream/VenueAnalysisStreamRequest';
import { WidgetId } from 'widgets/WidgetId';
import { DataServices } from 'store/Services';

const processStreamElement = (
    element: VenueAnalysisDataElement,
    nextState: VenueAnalysisStreamState
) => {
    const nextDataState: VenueAnalysisDataState = nextState.data ?? {
        ...initialVenueAnalysisDataState,
    };
    timeSeriesReducer(
        element as VenueAnalysisTimeSeriesElement<StreamElementType>,
        nextDataState,
        mapToVenueAnalysisDataTimeSeriesItemFromElement
    );
    streamMessagesReducer(element as StreamMessageElement, nextState);

    switch (element._c) {
        case VenueAnalysisStreamElementType.FILLINFO:
            nextDataState.fillInfo = mapFullInfoFromStream(element);
            break;
        case VenueAnalysisStreamElementType.QTYINFO:
            nextDataState.qtyInfo = mapQtyInfoFromStream(element);
            break;
        case VenueAnalysisStreamElementType.ORDERINFO:
            nextDataState.orderInfo = mapOrderInfoFromStream(element);
            break;
        case VenueAnalysisStreamElementType.MKTVOLHIST:
            nextDataState.mktVolHist = element.data;
            break;
        case VenueAnalysisStreamElementType.MKTVOLRT:
            nextDataState.mktVolRt = {
                ...nextDataState.mktVolRt,
                ...element.data,
            };
            break;
        default:
            break;
    }
};

const streamedDataCreateWidgetRequestUid = (
    state: State,
    services: DataServices,
    id: WidgetId,
    activeInputUsesOrdersStream: boolean
) =>
    Promise.resolve(
        createWidgetRequestUid(state, id, activeInputUsesOrdersStream)
    );

export function buildVenueAnalysisStreamSlice() {
    const selectVenueAnalysisStreamedData = (state: State) =>
        selectStreamedDataState(state).venueAnalysis;

    return buildStreamedDataStreamSlice(
        'startVenueAnalysisByOrderIdsOrSymbolStream',
        initialVenueAnalysisStreamState,
        selectVenueAnalysisStreamedData,
        streamedDataCreateWidgetRequestUid,
        toRequestUidForConfigOrSymbol,
        processStreamElement
    );
}

const {
    reducer: venueAnalysisStreamStreamedDataReducer,
    selectors: venueAnalysisStreamedDataSelectors,
} = buildVenueAnalysisStreamSlice();

export {
    venueAnalysisStreamStreamedDataReducer,
    venueAnalysisStreamedDataSelectors,
};
